import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Table } from "antd";
const SubProjectProductFamilyModal = ({ isModalOpen, handleOk, handleCancel, modalContent, title }) => {
    const columns = [
        {
            title: 'Product Model (Series Model)',
            dataIndex: 'productModel',
            key: 'productModel',
        },
        {
            title: 'Brand/OEM',
            dataIndex: 'brandName',
            key: 'brandName',
        },
    ];
    let addRemarksForDialog = false;
    let addFamilyFactInfoForDialog = false;
    let breakCountRemarks = 0;
    let breakCountFamilyFactInfo = 0;
    modalContent === null || modalContent === void 0 ? void 0 : modalContent.every((data) => {
        if (!breakCountRemarks && data.strRemarks) {
            addRemarksForDialog = true;
            breakCountRemarks++;
        }
        if (!breakCountFamilyFactInfo && data.strFactoryName) {
            addFamilyFactInfoForDialog = true;
            breakCountFamilyFactInfo++;
        }
        if (breakCountRemarks == 1 && breakCountFamilyFactInfo == 1) {
            return false;
        }
        return true;
    });
    if (addRemarksForDialog) {
        columns.push({
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
        });
    }
    if (addFamilyFactInfoForDialog) {
        columns.push({
            title: 'Factory / Importer / OEM',
            dataIndex: 'factoryName',
            key: 'factoryName',
        });
    }
    const dataSource = modalContent === null || modalContent === void 0 ? void 0 : modalContent.map((data, index) => {
        return {
            key: index,
            productModel: data === null || data === void 0 ? void 0 : data.strSeriesModel,
            brandName: data.objBrandName.strLongDesc,
            remarks: data.strRemarks,
            factoryName: data.strFactoryName,
        };
    });
    return (_jsx(Modal, { title: title, open: isModalOpen, onOk: handleOk, onCancel: handleCancel, children: _jsx(Table, { columns: columns, dataSource: dataSource }) }));
};
export default SubProjectProductFamilyModal;
